import React from 'react';
import { NavLink } from 'react-router-dom';

function Sidebar() {
   return (
      <div className="ppt_content_sidebar">
         <h3 className="ppt_sidebar_title mb-5">Sign In</h3>
         <div className="ppt_sidebar_logos">
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_log_01.png'} data-lightmodeimg alt="" border="0" />
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_log_02.png'} data-lightmodeimg alt="" border="0" />
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_log_03.png'} data-lightmodeimg alt="" border="0" />
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_log_04.png'} data-lightmodeimg alt="" border="0" />
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_log_05.png'} data-lightmodeimg alt="" border="0" />
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_log_06.png'} data-lightmodeimg alt="" border="0" />
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_log_07.png'} data-lightmodeimg alt="" border="0" />
            <img src={process.env.PUBLIC_URL + '/assets/img/icon_log_08.png'} data-lightmodeimg alt="" border="0" />
         </div>
         <span className="mt-auto"><img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" /></span>
      </div>
   );
}

export default Sidebar;